import { createMetricsFactory } from 'metrics-js';
import { getIsAcceptanceTest } from './testUtils';
export let Metrics;
export const setupMetricsFactory = namespace => {
  Metrics = createMetricsFactory(namespace, {
    dimensions: {
      isAcceptanceTest: `${getIsAcceptanceTest()}`
    }
  });
};